"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const react_router_dom_1 = require("react-router-dom");
const appSlice_1 = require("../store/slices/appSlice");
const store_1 = require("../store/store");
const useUser = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, store_1.useAppDispatch)();
    const loginMatch = (0, react_router_dom_1.useMatch)('/auth/*');
    const queryClient = (0, react_query_1.useQueryClient)();
    const fetchFunc = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const shouldFetchFromProsang = (_a = queryClient.getQueryState(['get-user'])) === null || _a === void 0 ? void 0 : _a.isInvalidated;
        try {
            const response = yield axios.get('/api/user', {
                params: {
                    fromServer: shouldFetchFromProsang ? true : null,
                },
            });
            const userResponse = response.data.user;
            dispatch((0, appSlice_1.setUser)(userResponse));
            return userResponse;
        }
        catch (_b) {
            if (!window.location.href.includes('/auth')) {
                navigate('/auth/logout'); // Only logout if not already on the logout or login page to prevent loops
            }
        }
    });
    return (0, react_query_1.useQuery)({
        queryKey: ['get-user'],
        queryFn: fetchFunc,
        staleTime: 1000 * 5 * 60, // 5 minutes
        enabled: !loginMatch,
    });
};
exports.default = useUser;
